export const CONTENT_MIN_WIDTH = 600;
